<div class="donors">
  <img loading="lazy" [attr.data-src]="supporterImg">
  <span><strong>{{subsCount?.monthlyDonors | inrFormat:'INR'}}</strong> contributors are giving monthly</span>
</div>